
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bmc-helix-itsm",
      function () {
        return require("private-next-pages/bmc-helix-itsm/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bmc-helix-itsm"])
      });
    }
  